import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Form, Button, Badge } from "react-bootstrap";

function Addfee() {
  const [students, setStudents]           = useState([]);
  const [studentId, setStudentId]         = useState("");
  const [studentName, setStudentName]     = useState("");
  const [standard, setStandard]           = useState("");
  const [month, setMonth]                 = useState("");
  const [totalAmount, setTotalAmount]     = useState("");
  const [paidAmount, setPaidAmount]       = useState("");
  const [dueDate, setDueDate]             = useState("");
  const [paidDate, setPaidDate]           = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [status, setStatus]               = useState("Upcoming");
  const [remarks, setRemarks]             = useState("");

  useEffect(() => {
    axios.get("/api/user/getallUser1").then((res) => {
      if (res.status === 200) setStudents(res.data.success || []);
    });
  }, []);

  const handleStudentChange = (e) => {
    const selected = students.find((s) => s._id === e.target.value);
    if (selected) {
      setStudentId(selected._id);
      setStudentName(selected.name);
      setStandard(selected.standard || "");
    }
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
    setPaidAmount("");
    setPaidDate("");
    setPaymentMethod("");
    setDueDate("");
  };

  const handleSubmit = async () => {
    if (!studentId || !month || !totalAmount) {
      alert("Please select Student, enter Month and Total Amount");
      return;
    }
    if (status === "Paid" && !paidAmount) {
      alert("Please enter Paid Amount");
      return;
    }
    try {
      const res = await axios.post("/api/admin/addfee", {
        studentId, studentName, standard, month, totalAmount,
        paidAmount:    (status === "Paid" || status === "Pending") ? paidAmount : 0,
        dueDate:       status !== "Paid" ? dueDate : "",
        paidDate:      status === "Paid" ? paidDate : "",
        paymentMethod: (status === "Paid" || status === "Pending") ? paymentMethod : "",
        status, remarks,
      });
      if (res.status === 200) {
        alert("Fee added successfully!");
        if (status === "Paid")     window.location.assign("/admin/feepaid");
        if (status === "Pending")  window.location.assign("/admin/feepending");
        if (status === "Upcoming") window.location.assign("/admin/feeupcoming");
      }
    } catch (error) {
      alert("Failed to add fee");
    }
  };

  // Status config
  const statusConfig = {
    Upcoming: { color: "#2196F3", bg: "#E3F2FD", label: "Fee is scheduled for future payment" },
    Pending:  { color: "#FF9800", bg: "#FFF3E0", label: "Fee is due but not yet paid"          },
    Paid:     { color: "#4CAF50", bg: "#E8F5E9", label: "Fee has been received"                },
  };
  const cfg = statusConfig[status];

  const field = (label, required, children) => (
    <Form.Group className="mb-3">
      <Form.Label style={{ fontWeight: 600, fontSize: "13px", color: "#444", marginBottom: "4px" }}>
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </Form.Label>
      {children}
    </Form.Group>
  );

  const inp = { borderRadius: "8px", border: "1px solid #ced4da", padding: "10px 14px", fontSize: "14px", width: "100%" };

  return (
    <div className="container py-4">
      <Card className="mx-auto shadow-sm" style={{ maxWidth: "580px" }}>
        <Card.Body className="p-4">

          <h5 className="text-center mb-4" style={{ color: "#01a695", fontWeight: 700 }}>
            Add Fee Entry
          </h5>

          {/* Student */}
          {field("Student", true,
            <Form.Select style={inp} onChange={handleStudentChange} defaultValue="">
              <option value="" disabled>-- Select Student --</option>
              {students.map((s) => (
                <option key={s._id} value={s._id}>
                  {s.name} — {s.email} (Std: {s.standard})
                </option>
              ))}
            </Form.Select>
          )}

          {/* Month */}
          {field("Month", true,
            <Form.Control style={inp} type="text" placeholder="e.g. April 2025"
              value={month} onChange={(e) => setMonth(e.target.value)} />
          )}

          {/* Total Amount */}
          {field("Total Amount (₹)", true,
            <Form.Control style={inp} type="number" placeholder="e.g. 5000"
              value={totalAmount} onChange={(e) => setTotalAmount(e.target.value)} />
          )}

          {/* Status */}
          {field("Status", true,
            <Form.Select style={inp} value={status} onChange={handleStatusChange}>
              <option value="Upcoming">Upcoming</option>
              <option value="Pending">Pending</option>
              <option value="Paid">Paid</option>
            </Form.Select>
          )}

          {/* Status info banner */}
          <div style={{ backgroundColor: cfg.bg, border: `1px solid ${cfg.color}`, borderRadius: "8px", padding: "10px 14px", marginBottom: "16px", display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{ width: "10px", height: "10px", borderRadius: "50%", backgroundColor: cfg.color, flexShrink: 0 }} />
            <span style={{ fontSize: "13px", color: cfg.color, fontWeight: 600 }}>{status} — </span>
            <span style={{ fontSize: "13px", color: "#555" }}>{cfg.label}</span>
          </div>

          {/* ── UPCOMING: Due Date only ── */}
          {status === "Upcoming" && (
            field("Due Date", false,
              <Form.Control style={inp} type="text" placeholder="e.g. 30 Apr 2025"
                value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
            )
          )}

          {/* ── PENDING: Partial paid + due date ── */}
          {status === "Pending" && (
            <>
              {field("Already Paid Amount (₹)", false,
                <Form.Control style={inp} type="number" placeholder="e.g. 2000 (if partial payment made)"
                  value={paidAmount} onChange={(e) => setPaidAmount(e.target.value)} />
              )}

              {/* Show due amount live */}
              {totalAmount && (
                <div style={{ backgroundColor: "#FFF3E0", border: "1px solid #FF9800", borderRadius: "8px", padding: "10px 14px", marginBottom: "16px" }}>
                  <span style={{ fontSize: "13px", color: "#FF9800", fontWeight: 600 }}>
                    Due Amount: ₹{Number(totalAmount) - Number(paidAmount || 0)}
                  </span>
                </div>
              )}

              {field("Due Date", false,
                <Form.Control style={inp} type="text" placeholder="e.g. 30 Apr 2025"
                  value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
              )}

              {field("Payment Method (if partial paid)", false,
                <Form.Select style={inp} value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                  <option value="">-- Select --</option>
                  <option value="Cash">Cash</option>
                  <option value="Online">Online</option>
                  <option value="UPI">UPI</option>
                  <option value="Cheque">Cheque</option>
                </Form.Select>
              )}
            </>
          )}

          {/* ── PAID: Paid Amount + Paid Date + Payment Method ── */}
          {status === "Paid" && (
            <>
              {field("Paid Amount (₹)", true,
                <Form.Control style={inp} type="number" placeholder="e.g. 5000"
                  value={paidAmount} onChange={(e) => setPaidAmount(e.target.value)} />
              )}
              {field("Paid Date", false,
                <Form.Control style={inp} type="text" placeholder="e.g. 15 Apr 2025"
                  value={paidDate} onChange={(e) => setPaidDate(e.target.value)} />
              )}
              {field("Payment Method", false,
                <Form.Select style={inp} value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                  <option value="">-- Select --</option>
                  <option value="Cash">Cash</option>
                  <option value="Online">Online</option>
                  <option value="UPI">UPI</option>
                  <option value="Cheque">Cheque</option>
                </Form.Select>
              )}
            </>
          )}

          {/* Remarks */}
          {field("Remarks", false,
            <Form.Control as="textarea" rows={2} placeholder="Optional notes"
              style={{ ...inp, height: "80px", resize: "none" }}
              value={remarks} onChange={(e) => setRemarks(e.target.value)} />
          )}

          <Button onClick={handleSubmit}
            style={{ backgroundColor: "#01a695", border: "none", width: "100%", padding: "12px", fontSize: "15px", fontWeight: 600, borderRadius: "8px" }}>
            Add Fee
          </Button>

        </Card.Body>
      </Card>
    </div>
  );
}

export default Addfee;
